import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid } from 'tessa/platform';
import { ArrayStorage } from 'tessa/platform/storage';
import { CardTask, CardTaskAction} from 'tessa/cards';
import { showConfirm} from 'tessa/ui';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { CdTaskTypes } from 'src/cdScripts/Helpers/CdTaskTypes';
import { DefaultCompletionOptions } from 'src/cdScripts/Helpers/DefaultCompletionOptions';
import { CdProcessHelper } from 'src/cdScripts/Helpers/CdProcessHelper';

export class CdCompleteTaskUIExtension extends CardUIExtension {

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
  }

  public async saving(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!(
      Guid.equals(context.model.card.typeId, CdCardTypes.PkIncomingTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.PkMemoTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.PkOutgoingTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.RdndTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.PkInternalDocumentationTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.PkAssignmentTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.PkLetterCreditTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.InstructionTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.ArActTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.ArDocumentIdpTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.TechnicalDocumentationTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.PkProtocolTenderTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.ArEDocumentTypeID) ||
      Guid.equals(context.model.card.typeId, CdCardTypes.PkPacketVirtualTypeID)
    )) {
        return;
    }
    
    let tasks = context.card.tasks;
    if (tasks == null || tasks.length < 1) {
        return;
    }

    await this.CheckControler(context, tasks);
    await this.CheckSubTasksClose(context, tasks);

  }

  private async CheckControler(context: ICardUIExtensionContext, tasks: ArrayStorage<CardTask>) {
    if (tasks == null) return;
    let task = tasks.find(t => (t.typeId === CdTaskTypes.PkCompleteTypeID ||
                                t.typeId === CdTaskTypes.PkConsiderationTypeID ||
                                t.typeId === CdTaskTypes.PkUksApprovalTaskTypeID ||
                                t.typeId === CdTaskTypes.PkProjectGroupApprovalTaskTypeID ||
                                t.typeId === CdTaskTypes.PkGipApprovalTaskTypeID ||
                                t.typeId === CdTaskTypes.PkOspApprovalTaskTypeID ||
                                t.typeId === CdTaskTypes.PkDepProductApprovalTaskTypeID ||
                                t.typeId === CdTaskTypes.PkExternalApprovalTaskTypeID ||
                                t.typeId == CdTaskTypes.PkTDComissionOnRenovationTypeID) &&
                                t.action === CardTaskAction.Complete &&
                                (t.optionId === DefaultCompletionOptions.CreateChildResolution ||
                                  t.optionId === CdProcessHelper.Relocate)
                            );
    if (task == null) {
        return;
    }

    let ptirSection = task.card.sections.tryGet('PkTaskIncomingResolution');
    if (ptirSection == null) return;
    let controlerID = ptirSection.fields.tryGet("ControlerID");
    if (controlerID == null) {
      const result = await showConfirm("Вы точно хотите отправить поручение без указания контролера? Если контролер не заполнен - контроль исполнения поручения не требуется");
      if (!result) {
        context.cancel = true;
      }
    }
  }

  private  async CheckSubTasksClose(context: ICardUIExtensionContext, tasks: ArrayStorage<CardTask>) {
    if (tasks == null) return;
    let task = tasks.find(t => (t.typeId === CdTaskTypes.PkCompleteTypeID ||
                                  t.typeId === CdTaskTypes.PkUksApprovalTaskTypeID ||
                                  t.typeId === CdTaskTypes.PkProjectGroupApprovalTaskTypeID ||
                                  t.typeId === CdTaskTypes.PkGipApprovalTaskTypeID ||
                                  t.typeId === CdTaskTypes.PkOspApprovalTaskTypeID ||
                                  t.typeId === CdTaskTypes.PkDepProductApprovalTaskTypeID ||
                                  t.typeId === CdTaskTypes.PkExternalApprovalTaskTypeID ||
                                  t.typeId === CdTaskTypes.PkStartAcquaintanceProcessTechDocTaskTypeID ||
                                  t.typeId == CdTaskTypes.PkTDComissionOnRenovationTypeID) &&
                                (t.action === CardTaskAction.Complete) &&
                                (t.optionId === DefaultCompletionOptions.Delegate ||
                                  t.optionId === DefaultCompletionOptions.Complete));
    if (task == null) {
        return;
    }
    let ptisvSection = task.card.sections.tryGet('PkTasksInfoSubtasksVirtual');
    if (ptisvSection == null) return;
    let existSubTasks = false;
    for (let row of ptisvSection.rows) {
        if (row.get("Completed") == null) {
            existSubTasks = true;
            break;
        }
    }
    if (existSubTasks) {
        let text = "";
        if (task.optionId === DefaultCompletionOptions.Delegate) {
            text = "Вы уверены, что хотите делегировать Поручение? Все отправленные подзадачи будут отозваны";
        }
        else {
            text = "Вы уверены, что хотите завершить Поручение? Все отправленные подзадачи будут отозваны";
        }
        const result = await showConfirm(text);
        if (!result) {
          context.cancel = true;
        }
      }
    }
}